<template>
    <div>
        <ol>
            <li v-for="ref in references" :key="ref">
                <span v-html="ref"></span>
            </li>
        </ol>
        <br>
        <br>
        <br>
        <div class="patterndesign">designed by <a target="_blank" href="https://pattern.broadinstitute.org/">PATTERNVIZLAB</a></div>
        <br>
    </div>
    
</template>

<script>
import text from "../assets/data/references.json";

export default {
    name: "References",
    data() {
        return {
            references: text,
        }
    },
}
</script>

